module.exports = __webpack_public_path__ + "img/cast_me.46db060b.png";